import styled, { css } from 'styled-components'

import Navbar from 'components/Navbar'
import Heading from 'components/Heading'
import { LinkButton } from 'components/Button'

import { breakpoint } from 'utils'

export const Wrapper = styled.div.attrs({ 'data-testid': 'index-layout' })`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 auto;
`

export const Header = styled(Navbar)`
  position: sticky;
  top: 0;
  padding: 0;
  z-index: 1;

  ${({ hasLink }) =>
    !hasLink &&
    css`
      border: none;
    `}
`

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 56px;
  border-right: 1px solid ${({ theme }) => theme.colors.border[2]};

  ${breakpoint('base', 'sm')`
    border-right: none;
  `}
`

export const FooterWrapper = styled.div`
  margin-top: auto;

  footer {
    padding-top: 40px;
  }
`

export const Main = styled.main<{
  isCreatingWorkspace?: boolean
  fullWidth?: boolean
  maxContainerWidth?: string
  isOnboardingLicensesSignupEnabled?: boolean
}>`
  width: 100%;
  max-width: ${({
    isOnboardingLicensesSignupEnabled,
    fullWidth,
    maxContainerWidth,
  }) =>
    fullWidth
      ? '100%'
      : isOnboardingLicensesSignupEnabled
      ? '636px'
      : maxContainerWidth
      ? maxContainerWidth
      : '500px'};

  ${({ isCreatingWorkspace }) =>
    isCreatingWorkspace ? `margin-top: 32px;` : `margin-top: 139px;`}

  ${breakpoint('base', 'sm')`
    padding: 0 16px;
    margin-top: 33px;
  `};
`

export const Text = styled.p`
  font-size: 0.8125rem;
  margin-right: 16px;
  color: ${({ theme }) => theme.colors.foreground.secondary[2]};
`

export const Subtitle = styled(Heading.H2)`
  font-size: ${({ theme }) => theme.fontSizes.xlarge};
  line-height: 1.5;
  text-align: center;
  font-weight: 400;

  margin-top: 8px;
  margin-bottom: 32px;

  ${breakpoint('sm')`
      font-size: 1.25rem;
      margin-top: 8px;
  `}
`

export const Title = styled.h1(
  ({ theme }) => css`
    margin-top: 0px;
    margin-bottom: 0;
    font-size: ${theme.fontSizes.xxlarge};
    text-align: center;
    line-height: 1;

    + :not(${/* sc-selector */ Subtitle}) {
      margin-top: 32px;
    }

    + ${Subtitle} {
      font-size: ${theme.fontSizes.body};
    }

    ${breakpoint('base', 'sm')`
      font-size: ${theme.fontSizes.xlarge};
    `}
  `
)

export const HeaderLinkButton = styled(LinkButton)`
  margin-right: 8px;
  color: ${({ theme }) => theme.colors.black};
`
